"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SHrPopup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_resizable_1 = require("react-resizable");
const SHrPopup_module_scss_1 = __importDefault(require("./SHrPopup.module.scss"));
require("./SHrPopup.scss");
const SHrPopup = (_a) => {
    var _b;
    var { triggerElement, children, handleShow = () => { }, screenStyles, type = "center", show = true } = _a, p = __rest(_a, ["triggerElement", "children", "handleShow", "screenStyles", "type", "show"]);
    const width = window.innerWidth;
    const resizeOptions = type === "resize-right" && "options" in p && p.options ? p.options : {};
    const height = window.innerHeight;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [triggerElement && (0, jsx_runtime_1.jsx)("div", { onClick: () => handleShow(true), children: triggerElement }), show && ((0, jsx_runtime_1.jsxs)("section", { className: `${SHrPopup_module_scss_1.default.contentC} ${SHrPopup_module_scss_1.default[type]}`, children: [(0, jsx_runtime_1.jsx)("div", { className: `${SHrPopup_module_scss_1.default.screen}`, onClick: () => handleShow(false), style: screenStyles }), type === "resize-right" ? ((0, jsx_runtime_1.jsx)(react_resizable_1.ResizableBox, { width: width < 700 ? width : width * ((_b = resizeOptions.widthMultiplier) !== null && _b !== void 0 ? _b : 0.7), height: height, axis: "x", onResize: (e, { size }) => size.width < 200 && handleShow(false), resizeHandles: ["w"], className: `${SHrPopup_module_scss_1.default.ResizableBox} ${!resizeOptions.disableAnimation && SHrPopup_module_scss_1.default.ResizeAnimation}}`, children: children })) : ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: children }))] }))] }));
};
exports.SHrPopup = SHrPopup;
